export const IMPORT_CHECKLIST = [
  "contacts.restrictions.fileExtension",
  "contacts.restrictions.headerRow",
  "contacts.restrictions.columnRestriction",
  "contacts.restrictions.contactColumns",
  "contacts.restrictions.supplierColumns",
];
